import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "parentCompanyFields",
    "designatedRepOther", "designatedRepPreviewFrame",
    "apContactOther", "apContactPreviewFrame",
    "previewSkeleton"
  ]

  toggleParentCompany(event) {
    this.parentCompanyFieldsTarget.style.display = event.target.checked ? "" : "none"
  }

  toggleDesignatedRep(event) {
    const value = event.target.value
    this.designatedRepOtherTarget.style.display = value === "" ? "" : "none"
    this.#updatePreview(this.designatedRepPreviewFrameTarget, value)
  }

  toggleApContact(event) {
    const value = event.target.value
    this.apContactOtherTarget.style.display = value === "" ? "" : "none"
    this.#updatePreview(this.apContactPreviewFrameTarget, value)
  }

  #updatePreview(frame, contactId) {
    if (!frame) return
    const template = frame.dataset.previewUrlTemplate
    if (contactId && template) {
      this.#injectSkeleton(frame)
      frame.src = template.replace("CONTACT_ID", contactId)
    } else {
      frame.removeAttribute("src")
      frame.innerHTML = ""
    }
  }

  #injectSkeleton(frame) {
    if (!this.hasPreviewSkeletonTarget) return
    const skeleton = this.previewSkeletonTarget.content.cloneNode(true)
    frame.replaceChildren(skeleton)
  }
}
